import { jsx as a, jsxs as h, Fragment as r } from "react/jsx-runtime";
import _, { forwardRef as y, useId as p, isValidElement as f, cloneElement as z } from "react";
import { c as n } from "./clsx-OuTLNxxd.js";
import { a as u } from "./Tooltip-CsEClBww.js";
import './Table.css';const W = "320px", H = "600px", j = "1025px", w = "_tableGroup_1mjz7_32", C = "_table_1mjz7_32", S = "_tableLabel_1mjz7_46", B = "_tableWrapper_1mjz7_64", T = "_tableCaption_1mjz7_82", N = "_tableRow_1mjz7_99", R = "_tableHeader_1mjz7_103", v = "_tableColumn_1mjz7_103", F = "_tableBody_1mjz7_113", D = "_tableCell_1mjz7_113", G = "_tableFooter_1mjz7_115", I = "_highlight_1mjz7_135", k = "_showDividers_1mjz7_169", L = "_cellWrapper_1mjz7_205", $ = "_headingText_1mjz7_132", E = "_columnWrapper_1mjz7_208", e = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: W,
  "mobile-wide": "480px",
  tablet: H,
  "tablet-wide": "800px",
  desktop: j,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  tableGroup: w,
  table: C,
  tableLabel: S,
  tableWrapper: B,
  tableCaption: T,
  tableRow: N,
  tableHeader: R,
  "tableRow-size--s": "_tableRow-size--s_1mjz7_103",
  tableColumn: v,
  "tableRow-size--m": "_tableRow-size--m_1mjz7_107",
  tableBody: F,
  tableCell: D,
  tableFooter: G,
  "headingText--mobile": "_headingText--mobile_1mjz7_132",
  highlight: I,
  showDividers: k,
  "highlight--green": "_highlight--green_1mjz7_188",
  "highlight--amber": "_highlight--amber_1mjz7_192",
  "highlight--red": "_highlight--red_1mjz7_196",
  "mobile-hide": "_mobile-hide_1mjz7_200",
  cellWrapper: L,
  headingText: $,
  columnWrapper: E
}, K = ({ children: i, className: t, row: l, ...o }) => /* @__PURE__ */ a("thead", { className: n(e.tableHeader, t), style: { "--gridRow": l }, ...o, children: i }), M = ({ children: i, className: t, ...l }) => /* @__PURE__ */ a("tbody", { className: n(e.tableBody, t), ...l, children: i }), O = ({ children: i, className: t, ...l }) => /* @__PURE__ */ a("tfoot", { className: n(e.tableFooter, t), ...l, children: i }), P = ({ children: i, className: t, size: l = "m", ...o }) => /* @__PURE__ */ a("tr", { className: n(e.tableRow, e[`tableRow-size--${l}`], t), ...o, children: i }), Q = ({ children: i, className: t, ...l }) => /* @__PURE__ */ a("caption", { className: n(e.tableCaption, t), ...l, children: i }), U = ({
  alignItems: i = "center",
  children: t,
  className: l,
  highlight: o,
  justifyContent: c = "flex-start",
  mobileText: s,
  mobileView: x,
  showDividers: m,
  toolTipSide: g,
  tooltipText: b,
  ...d
}) => /* @__PURE__ */ a(
  "th",
  {
    className: n(
      e.tableColumn,
      e[`mobile-${x}`],
      {
        [e.highlight]: o,
        [e.showDividers]: m
      },
      l
    ),
    ...d,
    children: /* @__PURE__ */ h(
      "div",
      {
        className: e.columnWrapper,
        style: {
          "--alignItems": i,
          "--justifyContent": c
        },
        children: [
          s ? /* @__PURE__ */ h(r, { children: [
            /* @__PURE__ */ a("span", { className: e["headingText--mobile"], children: s }),
            /* @__PURE__ */ a("span", { className: e.headingText, children: t })
          ] }) : /* @__PURE__ */ a(r, { children: t }),
          b && /* @__PURE__ */ a(u, { side: g, children: b })
        ]
      }
    )
  }
), X = ({
  alignItems: i = "center",
  children: t,
  className: l,
  highlight: o,
  justifyContent: c = "flex-start",
  showDividers: s,
  style: x,
  ...m
}) => /* @__PURE__ */ a(
  "td",
  {
    className: n(
      e.tableCell,
      {
        [e.highlight]: o,
        [e[`highlight--${o}`]]: o,
        [e.showDividers]: s
      },
      l
    ),
    style: {
      ...x,
      "--alignItems": c,
      "--justifyContent": i
    },
    ...m,
    children: /* @__PURE__ */ a("div", { className: e.cellWrapper, children: t })
  }
), Y = y(({ children: i, className: t, ...l }, o) => /* @__PURE__ */ a("div", { className: e.tableWrapper, "data-cxy-name": "table", children: /* @__PURE__ */ a("table", { className: n(e.table, t), ref: o, ...l, children: i }) })), Z = ({ children: i, className: t, label: l }) => {
  const o = p(), c = _.Children.map(
    i,
    (s) => f(s) ? z(s, {
      "aria-labelledby": o
    }) : s
  );
  return /* @__PURE__ */ h("div", { className: n(e.tableGroup, t), children: [
    l && /* @__PURE__ */ a("h3", { className: e.tableLabel, id: o, children: l }),
    c
  ] });
};
export {
  Y as T,
  M as a,
  Q as b,
  X as c,
  U as d,
  O as e,
  Z as f,
  K as g,
  P as h
};
